import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18f17272"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";

import tool from "@/utils/tool";
import router from "@/router/index";

      type FormInstance = InstanceType<typeof ElForm>;
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

store.dispatch("passwordModule/getAesKey");
    const passwordFormRef = ref<FormInstance>();

    const validateOldPassword = (rule: any, value: any, callback: any) => {
      if (value === "") {
        callback(new Error("请输入原密码"));
      } else {
        callback();
      }
    };

    const validatePassword = (rule: any, value: any, callback: any) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (passwordForm.checkPassword !== '') {
          if (!passwordFormRef.value) return
          passwordFormRef.value.validateField('checkPassword', () => null)
        }
        callback()
      }
    }

    const validatePassword2 = (rule: any, value: any, callback: any) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== passwordForm.password) {
        callback(new Error("两次输入的新密码不一致!"))
      } else {
        callback()
      }
    }

    const ustore = useStore();

    const bindData = reactive({
    });

    const passwordForm = reactive({
      oldPassword: "",
      password: "",
      checkPassword: "",
    });

    const rules = reactive({
      oldPassword: [{ validator: validateOldPassword, trigger: "blur" }],
      password: [{ validator: validatePassword, trigger: "blur" }],
      checkPassword: [{ validator: validatePassword2, trigger: "blur" }],
    });

    const submitForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.validate((valid) => {
        if (valid) {
          store.dispatch("passwordModule/updatePassword", passwordForm).then(
            (data) => {
              //成功
              ElMessage.success("保存成功.");
              formEl.resetFields();
            },
            (error) => {
              ElMessageBox.alert(error.msg, "系统消息", {
                confirmButtonText: "关闭",
                callback: (action: Action) => {},
              });
            }
          );
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    const resetForm = (formEl: FormInstance | undefined) => {
      console.log("exec...resetForm");
      if (!formEl) return;
      formEl.resetFields();
    };



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "passwordFormRef",
      ref: passwordFormRef,
      model: _unref(passwordForm),
      "status-icon": "",
      rules: _unref(rules),
      "label-width": "120px",
      class: "passwordForm",
      style: {"width":"430px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "原密码",
          prop: "oldPassword"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(passwordForm).oldPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(passwordForm).oldPassword) = $event)),
              type: "password",
              autocomplete: "off",
              "input-style": "width:300px"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "新密码",
          prop: "password"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(passwordForm).password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(passwordForm).password) = $event)),
              type: "password",
              autocomplete: "off",
              "input-style": "width:300px;margin-bottom:10px"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "确认新密码",
          prop: "checkPassword"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(passwordForm).checkPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(passwordForm).checkPassword) = $event)),
              type: "password",
              autocomplete: "off",
              "input-style": "width:300px"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_unref(ElButton), {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm(passwordFormRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_unref(ElButton), {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (resetForm(passwordFormRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}
}

})